<template>
  <div class="TotalCom">
    <div class="part1-content">
      <div class="top">
        <div class="content1">
          <img class="mag-img" :src="img1" alt="" />
          <div class="numBox numBox1">
            <p>
              本年度累计发表文献<span>{{
                yearCitationInfo.magArticleCount || "--"
              }}</span
              >篇
            </p>
          </div>
        </div>
        <img class="arrow-right" :src="arrowRight" alt="" />
        <div class="content2">
          <div
            id="chartYZWX1"
            :style="{
              width: '115px',
              height: '115px',
              margin: 'auto'
            }"
          />
          <div class="numBox numBox2">
            <p>
              其中<span>{{ yearCitationInfo.count }}</span
              >篇被<span>{{ yearCitationInfo.citationsCount || 0 }}</span
              >篇文献引用
            </p>
          </div>
        </div>
        <img class="arrow-right" :src="arrowRight" alt="" />
        <div class="content3">
          <div
            id="chartsYZWX2"
            :style="{
              width: '115px',
              height: '115px',
              margin: 'auto'
            }"
          />
          <div class="numBox numBox3">
            <p
              v-for="(item,
              index) in yearCitationInfo.citationsArticleCountGroupByType"
              :key="index"
            >
              <span class="dot" :style="{ background: colorArr[index] }"></span
              >{{ item.type }}：<span>{{ item.count }}</span
              >篇
            </p>
          </div>
        </div>
        <img class="arrow-right" :src="arrowRight" alt="" />
        <div class="content4">
          <div
            id="chartYZWX3"
            :style="{
              width: '115px',
              height: '115px',
              margin: 'auto'
            }"
          />
          <div class="numBox numBox4">
            <p>
              引证文献发表在学术期刊上的共<span>{{
                yearCitationInfo.qkCount || 0
              }}</span
              >篇，涵盖<span>{{ yearCitationInfo.citationsMagCount || 0 }}</span
              >本期刊
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GetSumIssueArticleCitation } from "@/api/emailPush";
export default {
  props: {
    year: {
      type: String,
      default: ""
    }
  },
  name: "TotalCom",
  data() {
    return {
      img1: require("@/assets/img/analysisReport/img1.png"),
      arrowRight: require("@/assets/img/analysisReport/arrow-right.png"),
      yearCitationInfo: {},
      colorArr: [
        "#5470C6",
        "#EE6666",
        "#91CC75",
        "#FAC858",
        "#37CBCB",
        "#90C340",
        "#F6B1B4",
        "#FC8452"
      ]
    };
  },
  computed: {
    ...mapGetters({
      magId: "magId"
    }),
    rate1() {
      if (!this.totalNumDataInfo.magAuthorArticleCount) {
        return "0%";
      }
      return (
        (
          (this.totalNumDataInfo.magAuthorArticleCount /
            this.totalNumDataInfo.magArticleCount) *
          100
        ).toFixed(2) + "%"
      );
    },
    rate2() {
      if (!this.totalNumDataInfo.citationsAuthorArticleCount) {
        return "0%";
      }
      return (
        (
          (this.totalNumDataInfo.citationsAuthorArticleCount /
            this.totalNumDataInfo.citationsCount) *
          100
        ).toFixed(2) + "%"
      );
    },
    rate3() {
      if (!this.totalNumDataInfo.citationsMagAuthorArticleCount) {
        return "0%";
      }
      return (
        (
          (this.totalNumDataInfo.citationsMagAuthorArticleCount /
            this.totalNumDataInfo.citationsMagArticleCount) *
          100
        ).toFixed(2) + "%"
      );
    }
  },
  watch: {
    year: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.getSumIssueArticleCitationInfo();
        }
      },
      deep: true
    },
    magId(nv) {
      if (nv) {
        // this.initData();
      }
    }
  },
  created() {},
  methods: {
    // getSumIssueArticleCitation() {
    //   let params = {
    //     magId: this.magId,
    //     startTime: this.year + "-01",
    //     endTime: this.year + "-12",
    //     size: 10
    //   };
    //   GetSumIssueArticleCitation(params).then(res => {
    //     if (res && res.data && res.data.status === 0) {
    //       let { data } = res.data;
    //       this.totalNumDataInfo = data;
    //       this.$nextTick(() => {
    //         this.chartYZWX(data);
    //         this.chartQKWX(data);
    //         this.chartXZFG(data);
    //         this.chartsYZWX2(data);
    //         this.chartXZFG2(data);
    //       });
    //     }
    //   });
    // },
    getSumIssueArticleCitationInfo() {
      let params = {
        magId: this.magId,
        startTime: this.year + "-01",
        endTime: this.year + "-12",
        size: 10
      };
      GetSumIssueArticleCitation(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          let { data } = res.data;
          this.yearCitationInfo = data;
          if (
            data.citationsArticleCountGroupByType &&
            data.citationsArticleCountGroupByType.length > 0
          ) {
            data.citationsArticleCountGroupByType.map(item => {
              if (item.type == "期刊") {
                this.yearCitationInfo.qkCount = item.count;
              }
            });
          } else {
            this.yearCitationInfo.qkCount = 0;
          }
          this.chartYZWX1();
          this.chartsYZWX2();
          this.chartYZWX3();
        }
      });
    },
    chartYZWX1() {
      if (!document.getElementById("chartYZWX1")) {
        return;
      }
      const myChart = this.$echarts.init(document.getElementById("chartYZWX1"));
      myChart.setOption(
        {
          color: ["#73C0DE ", "#E5E8F0"],
          title: {
            text: this.yearCitationInfo.citationsCount + "篇",
            left: "center",
            top: "50%",
            textStyle: {
              color: "#4054AF",
              fontSize: 16,
              align: "center",
              fontWeight: 500
            }
          },
          graphic: {
            type: "text",
            left: "center",
            top: "40%",
            style: {
              text: "引证文献",
              textAlign: "center",
              fill: "#999999",
              fontSize: 14,
              fontWeight: 500
            }
          },
          series: [
            {
              name: "引证文献",
              type: "pie",
              radius: ["100%", "70%"],
              label: {
                show: false,
                position: "left"
              },
              hoverAnimation: false,
              data: [
                {
                  value: this.yearCitationInfo.citationsCount
                }
              ]
            }
          ]
        },
        true
      );
    },
    chartsYZWX2() {
      if (!document.getElementById("chartsYZWX2")) {
        return;
      }
      var dataArr = this.yearCitationInfo.citationsArticleCountGroupByType;
      if (dataArr && dataArr.length > 0) {
        dataArr.map(item => {
          item.name = item.type;
          item.value = item.count;
        });
      }
      let _this = this;
      const myChart = this.$echarts.init(
        document.getElementById("chartsYZWX2")
      );
      myChart.setOption(
        {
          color: _this.colorArr,
          title: {
            text: _this.yearCitationInfo.citationsCount + "篇",
            left: "center",
            top: "50%",
            textStyle: {
              color: "#4054AF",
              fontSize: 16,
              align: "center",
              fontWeight: 500
            }
          },
          graphic: {
            type: "text",
            left: "center",
            top: "40%",
            style: {
              text: "引证文献",
              textAlign: "center",
              fill: "#999999",
              fontSize: 14,
              fontWeight: 500
            }
          },
          series: [
            {
              name: "引证文献",
              type: "pie",
              radius: ["100%", "70%"],
              label: {
                show: false,
                position: "left"
              },
              hoverAnimation: false,
              data: dataArr
            }
          ]
        },
        true
      );
    },
    chartYZWX3() {
      if (!document.getElementById("chartYZWX3")) {
        return;
      }
      const myChart = this.$echarts.init(document.getElementById("chartYZWX3"));
      myChart.setOption(
        {
          color: ["#8e8ed7", "#E5E8F0"],
          title: {
            text: this.yearCitationInfo.qkCount || 0 + "篇",
            left: "center",
            top: "50%",
            textStyle: {
              color: "#4054AF",
              fontSize: 16,
              align: "center",
              fontWeight: 500
            }
          },
          graphic: {
            type: "text",
            left: "center",
            top: "40%",
            style: {
              text: "期刊文献",
              textAlign: "center",
              fill: "#999999",
              fontSize: 14,
              fontWeight: 500
            }
          },
          series: [
            {
              name: "期刊文献",
              type: "pie",
              radius: ["100%", "70%"],
              label: {
                show: false,
                position: "left"
              },
              hoverAnimation: false,
              data: [
                {
                  value: this.yearCitationInfo.qkCount || 0
                }
              ]
            }
          ]
        },
        true
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.TotalCom {
  .part1-content {
    margin-top: 30px;
    background: #f5f7fd;
    padding: 30px;
    .numBox {
      text-align: center;
      color: #666;
      font-size: 14px;
      margin-top: 20px;
      .dot {
        width: 8px;
        height: 8px;
        display: inline-block;
        border-radius: 50%;
        margin-right: 4px;
      }
      span {
        color: #4054af;
      }
    }
    .top {
      display: flex;
      align-items: center;
    }
    .mag-img {
      width: 115px;
      height: 76px;
    }
    .arrow-right {
      width: 54px;
      height: 19px;
      margin: 0 20px;
    }
    .content1,
    .content2,
    .content3 {
      width: 19%;
      text-align: center;
    }
  }
}
</style>
